var bighouse = bighouse || {};

bighouse.template = (function () {

    function init() {

        util.log('Module loaded');

    }

    return {
        init: init
    };
})();